import { PanelContainer } from '../../common/panel/PanelContainer'
import Layout from '../common/Layout'
import { Period } from '../common/period'
import { Highlight } from './header/HightLight'
import { SelectScore } from './header/SelectScore'
import './lang/i18n'
import { PortfolioDistribution } from './portfolioDistribution'
import { ScoreTrend } from './scoreTrend'
import { TopCompanies } from './topCompanies'
import { TrendByPortfolio } from './trendByPortfolio'

const PortfolioScore = () => {
  const renderCustomHeader = () => {
    return <SelectScore />
  }

  const renderLeftBar = () => {
    return <Period />
  }

  const renderBottom = () => {
    return (
      <>
        <Highlight />
        <PanelContainer>
          <ScoreTrend />
          <PortfolioDistribution />
          <TopCompanies />
          <TrendByPortfolio />
        </PanelContainer>
      </>
    )
  }

  return (
    <Layout
      renderCustomHeader={renderCustomHeader}
      renderLeftBar={renderLeftBar}
      renderBottom={renderBottom}
    />
  )
}

export default PortfolioScore
